'use strict';

var React = require('react');

var SvgSmileySadIcon = function SvgSmileySadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.5 10a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm1.5 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-7.957 2.69a2.5 2.5 0 0 1 2.725.542.75.75 0 1 0 1.06-1.06 3.998 3.998 0 0 0-5.656 0 .75.75 0 1 0 1.06 1.06 2.5 2.5 0 0 1 .811-.542Zm1.707-4.94a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Zm-2.25-.75a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75Z"
  }));
};
SvgSmileySadIcon.displayName = "SmileySadIcon";

exports.SvgSmileySadIcon = SvgSmileySadIcon;
